<template>
  <div>
    <p class="timer navbar-brand">{{ formattedTime(timer) }}</p>
  </div>
</template>

<script>
import { format, addSeconds } from "date-fns";

export default {
  name: "Timer",
  props: {
    update: Boolean,
  },
  emits: ["update"],
  data: () => ({
    timer: 600,
  }),
  mounted() {
    this.countDown();
  },
  methods: {
    formattedTime(seconds) {
      if (seconds >= 0) {
        var tempDate = addSeconds(new Date(0), seconds);
        return format(tempDate, "mm:ss");
      } else {
        this.timer = 0;
        this.$parent.$emit("update", true);
        this.timer = 600;
      }
    },
    countDown() {
      setInterval(() => this.timer -= 1, 1000);
    },
  }
};
</script>

<style>
.timer {
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 0 !important;
}
</style>
